import { SDashboardSectionPlaceholder, SStack } from './SectionEmptyState.styled'
import { Text } from 'components/Typography'
import { ReactNode } from 'react'
import { Icon, IconName } from 'components/icon'

interface Props {
  icon: IconName
  title: string
  description: string
  buttons?: ReactNode
  className?: string
}

export function SectionEmptyState({ icon, title, description, buttons, className }: Props) {
  return (
    <section className={className}>
      <SDashboardSectionPlaceholder>
        <Icon name={icon} size="1.75rem" />

        <Text variant="bodyLargeBold" color="black">
          {title}
        </Text>

        <Text css={{ maxWidth: '18rem' }} variant="bodySmall">
          {description}
        </Text>

        <SStack space="1rem" orientation={['vertical', 'horizontal']}>
          {buttons}
        </SStack>
      </SDashboardSectionPlaceholder>
    </section>
  )
}
